import { CubeQuery } from '../../../types/cube';

export const PartnerScoreCacheKeys = {
  all: ['partner-score'] as const,
  filter: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'filter', query] as const,
  survey: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'survey', query] as const,
  willing: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'willing', query] as const,
  individualScore: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'individual-score', query] as const,
  partnerScoreFilter: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'ps-filter', query] as const,
  customerSatisfactionScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'customer-satisfaction-score', query] as const,
  customerUnSatisfactionScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'customer-un-satisfaction-score', query] as const,
  individualCustomerSatisfactionScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'individual-customer-satisfaction-score', query] as const,
  averageCustomerSatisfactionScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'average-customer-satisfaction-score', query] as const,
  netPromoterScore: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'nps', query] as const,
  averageNetPromoterScore: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'average-nps', query] as const,
  averageNetPromoterScore2: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'average-nps-2', query] as const,
  averagePartnerScore: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'average-partner-score', query] as const,
  contactPerson: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'contact-person', query] as const,
  customerEngagementSatisfactionScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'customer-engagement-satisfaction-score', query] as const,
  customerEngagementUnSatisfactionScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'customer-engagement-un-satisfaction-score', query] as const,
  customerEngagementIndividualScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'customer-engagement-individual-score', query] as const,
  customerEffortChart: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'customer-effort-chart', query] as const,
  cesSurvey: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'ces-survey', query] as const,
  cesAverage: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'ces-average', query] as const,
  listOfRespondents: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'l-o-r', query] as const,
  cesCsatSatisfactionChart: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'csat-satisfaction-chart', query] as const,
  cesPartnerScoreRelationshipFeedbackTable: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'relation-ship-table', query] as const,
  cesPartnerScoreRelationshipFeedbackTableGoodExample: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'relation-ship-good-example', query] as const,
  npsLoyaltyCustomer: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'nps-loyalty-customer', query] as const,
  npsLoyaltyCustomerCompetitor: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'nps-loyalty-customer-competitor', query] as const,
  engagementQualities: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-engagement-qualities', query] as const,
  overallEngagementQualities: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-overall-engagement-qualities', query] as const,
  csatSatisfiedFeedbackTable: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'csat-satisfied-feedback-table', query] as const,
  csatUnSatisfiedFeedbackTable: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'csat-unsatisfied-feedback-table', query] as const,
  cesPartnerScoreNoPrimaryContactPointTable: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'csat-partner-score-no-primary-contact', query] as const,
  cesPresenceOfAPrimaryContact: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'ces-score-presence-of-a-primary-contact', query] as const,
  partnership: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'partner-score-partnership', query] as const,
  relationshipTypeDonuts: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-relationship-type-donuts', query] as const,
  relationshipTypeCharts: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-relationship-type-charts', query] as const,
  verbatimComments: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'verbatimComments', query] as const,
  partnershipWithRocheDonut: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-partnership-with-roche-donuts', query] as const,
  partnershipWithRocheBarChart: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-partnership-with-roche-bar-chart', query] as const,
  partnershipWithRocheDonutChart: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-partnership-with-roche-donut-chart', query] as const,
  averageCompetitorPartnerScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'average-competitor-partner-score', query] as const,
  averageCompetitorEffortScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'average-competitor-effort-score', query] as const,
  partnershipVerbatimComments: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-parnership-verbatim-comments', query] as const,
  averageCompetitorNps: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'average-competitor-nps', query] as const,
  highestPartnerScore: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'highest-partner-score', query] as const,
  partnerScoreDataAvailability: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-data-availability', query] as const,
  competitorFilter: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'competitor-filter', query] as const,
  competitorSurveyTitles: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'competitor-survey-titles', query] as const,
  partnerScoreDataCompetitorsOverallExperience: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-competitors-overall-experience', query] as const,
  partnerScoreDataCompetitorsOverallExperienceTrustAndCompetition: (query: CubeQuery) =>
    [
      ...PartnerScoreCacheKeys.all,
      'partner-score-competitors-overall-experience-trust-and-competition',
      query,
    ] as const,
  partnerScoreDataCompetitorsOverallExperienceOutcome: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-competitors-overall-experience-outcome', query] as const,
  partnerScoreDataCompetitorsOverallExperienceEmotionAndConnection: (query: CubeQuery) =>
    [
      ...PartnerScoreCacheKeys.all,
      'partner-score-competitors-overall-experience-emotion-and-connection',
      query,
    ] as const,

  highestCompetitorEffortScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'highest-competitor-effort-score', query] as const,
  highestCustomerNPS: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'highest-customer-nps', query] as const,
  partnerScoreDataAvailabilityCompetitor: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'partner-score-data-availability-competitor', query] as const,
  highestCustomerSatisfactionScore: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'highest-customer-satisfaction-score', query] as const,
  stackedRelationshipTypeChart: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'stacked-relationship-type-chart', query] as const,
  primaryPointOfContactAwareness: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'primary-point-of-contact-awareness', query] as const,
  competitorRelationshipTypeDonuts: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'competitor-relationship-type-donuts', query] as const,
  satisfactionVerbatimComments: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'competitor-satisfaction-verbatim-comments', query] as const,
  customerSatisfactionData: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'csat-customer-satisfaction-data', query] as const,
  quantifiablecustomersatisfactionmetric: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'competitor-satisfaction-quantifiable-customer-sat', query] as const,
  effortVerbatimComments: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'competitor-effort-verbatim-comments', query] as const,
  inanparthershipwithcompany: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'competitor-in-an-parthership-with-company', query] as const,
  csatVerbatimComments: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'csat-verbatim-comments', query] as const,
  cesPartnerScoreEffortVerbatimComments: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'ces-partner-score-effort-verbatim-comments', query] as const,
  npsVerbatimComments: (query: CubeQuery) => [...PartnerScoreCacheKeys.all, 'nps-verbatim-comments', query] as const,
  partnerScoreSurveyList: (query: CubeQuery) =>
    [...PartnerScoreCacheKeys.all, 'ces-partner-score-survey-list', query] as const,
};
